import useTheme from '@material-ui/core/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

/**
 * uses theme with use-media-query hook
 * @param {string} bp
 * @returns boolean result of useMediaQuery
 */
export const useResponsiveBreakpoint = (bp) => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down(bp))
}
